// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from '@/store'
import router from './router'
import VuejsDialog from 'vuejs-dialog'
import VueAnalytics from 'vue-analytics'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import VueBrowserUpdate from 'vue-browserupdate'
import EventBus from './components/EventBus/event-bus'

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'validateErrors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'validateFields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false
}

Vue.use(VeeValidate, config)
Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(VuejsDialog)
Vue.use(VueAnalytics, {id: 'UA-119007511-3', router})
// https://www.npmjs.com/package/vue-browserupdate
// http://browser-update.org/customize.html
Vue.use(VueBrowserUpdate, {
  options: {
    required: {i: 11},
    reminder: 0
  },
  shift_page_down: true
})

router.beforeEach((to, from, next) => {
  if (to.query.templateid !== undefined || to.query.app !== undefined) {
    localStorage.setItem('externalRunScanParams', JSON.stringify(to.query))
  }
  if (to.query.report_id !== undefined) {
    localStorage.setItem('externalReportHistory', JSON.stringify(to.query))
    localStorage.setItem('PendingReport', '0')
  }
  // console.log('externalReportHistory', localStorage.getItem('externalReportHistory'))

  let currentRole = store.state.currentRole
  let passwordChangeRequired = store.state.passwordChangeRequired
  let allowedRouteNames = ['My Profile', 'logout', 'login'].map(function (currentValue, index, array) {
    return currentValue.toLowerCase()
  })

  if (to.meta !== undefined && to.meta.roles !== undefined && to.meta.roles.indexOf('Everyone') !== -1) {
    next()
    return
  }

  if (passwordChangeRequired && document.cookie.indexOf('.jwt=') === -1) {
    store.commit('LOGOUT_USER')
    passwordChangeRequired = false
  }

  if (document.cookie.indexOf('.jwt=') === -1 && to.name.indexOf('login') === -1) {
    next('/login')
    return
  }

  if (passwordChangeRequired && allowedRouteNames.indexOf(to.name.toLowerCase()) === -1) {
    next(false)
    alert('You have to change your password before you continue to use this application.')
    return
  }

  if (to.meta !== undefined && to.meta.roles !== undefined && to.meta.roles.indexOf(currentRole) === -1) {
    alert('Access denied')
    next(false)
    return
  }

  if (to.meta !== undefined && to.meta.IsAcademy === true) {
    const token = store.getters.GetAcademyToken
    const url = store.getters.GetAcademyURL
    setTimeout(function () {
      window.open(url + token, '_blank')
      window.location.href = window.location.href
    }, 0)

    next(false)
    return
  }

  if (to.meta !== undefined && to.meta.subscription !== undefined) { // && !store.state.isInternalStaff) {
    let currentSubscription = store.state.subscriptions
    if (to.meta.subscription.length > 1) {
      let hasFeature = false
      to.meta.subscription.forEach(s => {
        if (currentSubscription.indexOf(s) > -1) {
          hasFeature = true
          if (to.meta.url !== undefined) {
            window.location = to.meta.url
          } else {
            next()
          }
        }
      })
      if (!hasFeature) {
        EventBus.$emit('FeatureSubscriptionEvent', to.name)
        next(false)
      }
    } else {
      if (currentSubscription.indexOf(to.meta.subscription) === -1) {
        EventBus.$emit('FeatureSubscriptionEvent', to.name)
        next(false)
      } else {
        if (to.meta.url !== undefined) {
          window.location = to.meta.url
        } else {
          next()
        }
      }
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  beforeCreate () {

  },
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js